  /* Colour Pop Kits — before/after drag reveal. */
  (function () {
    var reveal0 = document.querySelector('[data-cpk-reveal]');
    var root = reveal0 && reveal0.closest('.shopify-section');
    if (!root) { return; }
    var reveal = root.querySelector('[data-cpk-reveal]');
    if (!reveal) { return; }

    var dragging = false;
    var beforeTag = reveal.querySelector('.cpk-reveal__tag--before');
    var afterTag = reveal.querySelector('.cpk-reveal__tag--after');

    /* Hide a pill once the divider slides over it, so the handle never
       crosses the label. Compares the divider's x against each pill's own
       edge, measured live so it adapts to label width. */
    function updatePills(pct) {
      var r = reveal.getBoundingClientRect();
      var dividerX = r.left + r.width * (pct / 100);
      if (beforeTag) {
        var b = beforeTag.getBoundingClientRect();
        beforeTag.classList.toggle('is-hidden', dividerX <= b.right);
      }
      if (afterTag) {
        var a = afterTag.getBoundingClientRect();
        afterTag.classList.toggle('is-hidden', dividerX >= a.left);
      }
    }

    function setPos(clientX) {
      var r = reveal.getBoundingClientRect();
      var pct = (clientX - r.left) / r.width * 100;
      pct = Math.max(0, Math.min(100, pct));
      reveal.style.setProperty('--cpk-reveal-pos', pct.toFixed(2) + '%');
      reveal.setAttribute('aria-valuenow', Math.round(pct));
      updatePills(pct);
    }

    reveal.addEventListener('pointerdown', function (e) {
      dragging = true;
      reveal.setPointerCapture && reveal.setPointerCapture(e.pointerId);
      setPos(e.clientX);
      e.preventDefault();
    });
    reveal.addEventListener('pointermove', function (e) {
      if (dragging) { setPos(e.clientX); }
    });
    function endDrag() {
      dragging = false;
    }
    reveal.addEventListener('pointerup', endDrag);
    reveal.addEventListener('pointercancel', endDrag);
    reveal.addEventListener('lostpointercapture', endDrag);

    /* keyboard support for the slider role */
    reveal.addEventListener('keydown', function (e) {
      var now = parseFloat(reveal.getAttribute('aria-valuenow')) || 50;
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft') { now -= step; }
      else if (e.key === 'ArrowRight') { now += step; }
      else if (e.key === 'Home') { now = 0; }
      else if (e.key === 'End') { now = 100; }
      else { return; }
      now = Math.max(0, Math.min(100, now));
      reveal.style.setProperty('--cpk-reveal-pos', now + '%');
      reveal.setAttribute('aria-valuenow', Math.round(now));
      updatePills(now);
      e.preventDefault();
    });

    /* Sync pill visibility to the starting divider position. */
    updatePills(parseFloat(reveal.getAttribute('aria-valuenow')) || 50);
  })();
